
angular.module('bmsApp.responses').factory('LastError', function ($log, $window) {
	var lastError = undefined;

	function setError(error){
		$window.localStorage["lastError"] = JSON.stringify(error);
	}
	function getError(){
		return JSON.parse($window.localStorage["lastError"]);
	}

    return {
        setError: setError,
        getError: getError
    };
});
